/**
 * Componente/interceptor
 *
 * @author Ronald J Llusco - 79746003<lluscovillarpando@gmail.com>
 * @version 1.0.0
 * @license MIT
 */
import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpContextToken, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { ErrorLogsService } from '../services/error-logs.service';
import { AuthService } from 'src/app/auth/auth.service';

export const NotUseJWT = new HttpContextToken(() => false);

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private errorLogsService: ErrorLogsService,
    private injector: Injector
  ) {}

  get token(): string {
    return sessionStorage.getItem('token') || '';
  }

  get headerToken() {
    return new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.context.get(NotUseJWT)) {
      return next.handle(req);
    }

    const reqClone = req.clone({ headers: this.headerToken });
    return next.handle(reqClone).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          const authService = this.injector.get(AuthService);
          if (!req.url.includes('/auth') && authService.refreshToken && !this.isRefreshing) {
            this.isRefreshing = true;
            return authService.refresh().pipe(
              switchMap((refreshed) => {
                this.isRefreshing = false;
                if (refreshed) {
                  const retryReq = req.clone({
                    headers: new HttpHeaders({
                      'Authorization': 'Bearer ' + authService.token
                    })
                  });
                  return next.handle(retryReq);
                } else {
                  authService.logout();
                  return throwError(() => err);
                }
              }),
              catchError((refreshErr) => {
                this.isRefreshing = false;
                authService.logout();
                return throwError(() => refreshErr);
              })
            );
          }
        }

        if (err.name === 'TimeoutError') {
          err.status = 999;
        }
        this.errorLogsService.logDeErrores(err);
        return throwError(() => err);
      })
    );
  }
}
